// Maps current pathname → pageKey from app_pages_catalog.
// Order matters — first matching prefix wins. Public/util routes return null (unrestricted).

export const PAGE_KEY_PREFIXES: Array<[string, string]> = [
  ["/sales/invoices", "sales.invoices"],
  ["/sales/orders", "sales.quotations"],
  ["/sales/customers", "sales.customers"],
  ["/sales/returns", "sales.returns"],
  ["/sales/products", "inventory.products"],
  ["/purchases/invoices", "purchases.invoices"],
  ["/purchases/orders", "purchases.quotations"],
  ["/purchases/vendors", "purchases.vendors"],
  ["/purchases/returns", "purchases.returns"],
  ["/inventory/products", "inventory.products"],
  ["/inventory/receipts", "inventory.receipts"],
  ["/inventory/issues", "inventory.issues"],
  ["/inventory/transfers", "inventory.transfers"],
  ["/inventory/stock-takes", "inventory.stock_takes"],
  ["/inventory/srn", "inventory.srn"],
  ["/inventory/damages", "inventory.damages"],
  ["/journal", "journal.entries"],
  ["/vouchers/payment", "finance.payment_vouchers"],
  ["/vouchers/payments", "finance.payment_vouchers"],
  ["/vouchers/receipt", "finance.receipt_vouchers"],
  ["/vouchers/receipts", "finance.receipt_vouchers"],
  ["/finance/cash-counts", "finance.cash_counts"],
  ["/finance/custodies", "finance.cash_custodies"],
  ["/closing-review", "finance.closing_review"],
  ["/assets/vouchers", "assets.vouchers"],
  ["/assets/disposals", "assets.disposals"],
  ["/assets", "assets.list"],
  ["/asset-custody-transfer", "assets.custody_transfer"],
  ["/leases", "leases.contracts"],
  ["/expenses/prepaid", "expenses.prepaid"],
  ["/expenses/accrued", "expenses.accrued"],
  ["/projects", "projects.construction"],
  ["/reports/sales", "reports.sales"],
  ["/reports/purchases", "reports.purchases"],
  ["/reports/inventory", "reports.inventory"],
  ["/reports/tax-return", "reports.tax"],
  ["/reports/assets", "reports.assets"],
  ["/reports/leases", "reports.leases"],
  ["/reports/prepaid", "reports.prepaid"],
  ["/reports/analytics", "reports.analytics"],
  ["/reports", "reports.financial"],
  ["/opening-balances", "setup.opening_balances"],
  ["/setup/accounts", "setup.accounts"],
  ["/setup/cost-centers", "setup.cost_centers"],
  ["/setup/warehouses", "setup.warehouses"],
  ["/setup/taxes-zakat", "setup.taxes"],
  ["/setup/document-numbering", "setup.numbering"],
  ["/setup/fiscal-periods", "setup.fiscal_periods"],
  ["/setup/product-categories", "setup.product_categories"],
  ["/setup/asset-groups", "setup.asset_groups"],
  ["/setup/damage-reasons", "setup.damage_reasons"],
  ["/setup/cash-denominations", "setup.cash_denominations"],
  ["/settings/company", "settings.company"],
  ["/settings/members", "settings.members"],
  ["/settings/roles", "settings.roles"],
  ["/settings/ai", "settings.ai"],
];

// Routes always allowed (no page-key gate)
const UNRESTRICTED_PREFIXES = [
  "/dashboard", "/profile", "/companies", "/ai", "/billing", "/integrations",
  "/help", "/change-password",
  "/support",              // support tickets open to every signed-in user
  "/inventory/integrity",  // technical tool — owner/admin only in practice
  "/sales/print-settings", // belongs to company settings
];

export function getPageKeyForPath(pathname: string): string | null {
  if (UNRESTRICTED_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"))) return null;
  for (const [prefix, key] of PAGE_KEY_PREFIXES) {
    if (pathname === prefix || pathname.startsWith(prefix + "/")) return key;
  }
  return null;
}

// Detect whether the current path is an edit/create route — last segment is
// `new` or `edit`. Used to require `edit` level instead of `view`.
export function isEditRoute(pathname: string): boolean {
  const segs = pathname.split("/").filter(Boolean);
  const last = segs[segs.length - 1];
  return last === "new" || last === "edit";
}
